import { classString } from 'helpers'
import SesoLogo from '../assets/Seso'

const seso = {
  getImage: ({ className, ...props } = {}) => (
    <SesoLogo
      className={classString(['seso', className, 'newLogo'])}
      {...props}
    />
  ),
  getURL: (variant) => 'https://www.sesolabor.com',
}

export default seso
